import React, { useState, useEffect } from "react";
import { getRateGain } from "../../../api/endpoints/allReports";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message } from "antd";
import Example from "./calling.js";
import SideBar from "../../sidebar/sideBar";
import Header from "../../header/header";
import { getAllItemsSearch } from "../../../api/endpoints/search";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Select } from "antd";

const { Option } = Select;
 
const RateGainReport = () => {
  const { user, access_token } = useSelector(authSelector);
  const [siteName, setSiteName] = useState();
  const [siteAddress, setSiteAddress] = useState();
  const [itemsQueue, setItemsQueue] = useState([]);
  const [state, setState] = useState({
    items: [],
    startingDate: "",
    endingDate: "",
    itemCode: "",
    itemName: "",
  });

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };

  const clearState = () => {
    setItemsQueue([]);
  };

  const clearFields = () => {
    setState({
      items: state.items,
      itemCode: "",
      itemName: "",
      endingDate: "",
      startingDate: "",
    });
  };
  function formatDate(inputDate) {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = new Date(inputDate).toLocaleDateString(
      undefined,
      options
    );
    return formattedDate;
  }

  const formatDateDDMMYYYY = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    const day = d.getDate();
    const month = d.getMonth() + 1; // months are 0-based
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const [loading, setLoading] = useState(false);
  const editHandler = async (e) => {
    if (!state.startingDate && !state.endingDate)
      return message.error("Please type date !");
    // if (!state.itemCode) return message.error("Please type Item !");
    let data = {
      startingDate: state.startingDate,
      endingDate: state.endingDate,
      itemCode: state.itemCode,
      // siteId: Number(user.siteId),
    };

    console.log(state, "ressaaaaa");
    const results = await getRateGain(data, access_token);
    if (results.data.length === 0) {
      message.error("No Record Found in this date");
    }
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            enteredOn: curr.enteredOn,
            // shift: curr.shift,
            itemCode: Number(curr.itemCode),
            itemName: curr.item.itemName,
            LastIndentPrice: Number(curr.LastIndentPrice),
            LastSalePrice: Number(curr.LastSalePrice),
            SalePrice: Number(curr.SalePrice),
            IndentPrice: Number(curr.IndentPrice),
            BalQty: Number(curr.BalQty),
            amount: Number(curr.amount),
            change: Number(curr.change),
            siteId: curr.siteId,
          },
        ];
      }, []);
        setItemsQueue(payload);
        generatePDF(payload);
    } else {
      message.error(results.message);
    }
  };

  const getAllData = async () => {
    const _items = await getAllItemsSearch(access_token);
    setState({
      ...state,
      items: _items,
    });
  };
  useEffect(() => {
    getAllData();

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

const generatePDF = (data) => {
  if (!data || data.length === 0) {
    message.error("No data to generate report!");
    return;
  }

  const doc = new jsPDF("p", "mm", "a4");

  // =====================================================
  // HEADER
  // =====================================================

  const now = new Date();

  const printDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

  doc.setFontSize(8);
  doc.text(`Printed on: ${printDateTime}`, 200, 5, {
    align: "right",
  });

  doc.setFontSize(16);
  doc.text(`${siteName || ""}`, 103, 11, {
    align: "center",
  });

  doc.setFontSize(12);
  doc.text(`${siteAddress || ""}`, 103, 16, {
    align: "center",
  });

  doc.setFontSize(11);
  doc.text("Rate Gain / Loss", 103, 21, {
    align: "center",
  });

  doc.setFontSize(9);
  doc.text(
    `From: ${formatDate(state.startingDate)} To: ${formatDate(
      state.endingDate
    )}`,
    103,
    26,
    {
      align: "center",
    }
  );

  // =====================================================
  // ITEM
  // =====================================================

  if (state.itemName) {
    doc.setFontSize(10);

    doc.text(`Item: ${state.itemName}`, 103, 31, {
      align: "center",
    });
  }

  // =====================================================
  // TABLE ROWS
  // =====================================================

  const tableRows = data.map((ele) => [
    ele.enteredOn
      ? formatDateDDMMYYYY(ele.enteredOn)
      : "",

    ele.itemName || "",

    Number(ele.change || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),

    Number(ele.IndentPrice || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),

    Number(ele.SalePrice || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),

    Number(ele.LastIndentPrice || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),

    Number(ele.LastSalePrice || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),

    Number(ele.BalQty || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),

    Number(ele.amount || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
  ]);

  // =====================================================
  // TOTAL AMOUNT
  // =====================================================

  const totalAmount = data.reduce(
    (sum, ele) => sum + (Number(ele.amount) || 0),
    0
  );

  // =====================================================
  // TOTAL ROW
  // =====================================================

  tableRows.push([
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "Total",
    totalAmount.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
  ]);

  // =====================================================
  // PDF TABLE
  // =====================================================

  autoTable(doc, {
    head: [
      [
        "Date",
        "Item Name",
        "Change",
        "Indent Price",
        "Sale Rate",
        "Last Indent",
        "Last Sale",
        "Quantity",
        "Amount",
      ],
    ],

    body: tableRows,

    startY: state.itemName ? 35 : 30,

    theme: "grid",

    margin: {
      left: 2,
      right: 2,
    },

    styles: {
      fontSize: 9,
      cellPadding: 1.5,
      textColor: [0, 0, 0],
      lineColor: [0, 0, 0],
      lineWidth: 0.3,
      valign: "middle",
    },

    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontStyle: "bold",
      halign: "center",
      valign: "middle",
      lineColor: [0, 0, 0],
      lineWidth: 0.5,
    },

    columnStyles: {
      0: {
        halign: "center",
        cellWidth: 18,
      },

      1: {
        halign: "left",
        cellWidth: 25,
      },

      2: {
        halign: "right",
        cellWidth: 18,
      },

      3: {
        halign: "right",
        cellWidth: 24,
      },

      4: {
        halign: "right",
        cellWidth: 24,
      },

      5: {
        halign: "right",
        cellWidth: 24,
      },

      6: {
        halign: "right",
        cellWidth: 24,
      },

      7: {
        halign: "right",
        cellWidth: 22,
      },

      8: {
        halign: "right",
        cellWidth: 25,
      },
    },

    didParseCell: (data) => {
      // Make Total row bold
      if (data.row.index === tableRows.length - 1) {
        data.cell.styles.fontStyle = "bold";
      }
    },
  });

  // =====================================================
  // OPEN PDF IN NEW TAB
  // =====================================================

  const pdfBlob = doc.output("blob");

  const pdfUrl = URL.createObjectURL(pdfBlob);

  window.open(pdfUrl);
};

  return (
    
        <>
          <div className="flex  bg-black main">
            <SideBar />
            <div className="h-full  flex flex-col content-center  w-full">
              <Header />
              <div className="flex justify-center mt-10">
                <div className="meterTableMain flex flex-col justify-center w-1/2 ml-10 mt-5 mr-10">
                  <div className="bg-blue-500 headingBox flex justify-center">
                    <h1 className="text-white ">Rate Gain Loss</h1>
                  </div>
                  <div className="flex flex-col content-center items-center justify-items-center justify-evenly">
                    <div className="mt-4">
                      <div className="flex items-center">
                        <label className="text-white" htmlFor="startDate">
                          Starting Date:
                        </label>
                        <input
                          type="date"
                          name="startingDate"
                          className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                          onChange={onChangeText}
                        />
                        <label className="text-white ml-5" htmlFor="endDate">
                          Ending Date:
                        </label>
                        <input
                          type="date"
                          name="endingDate"
                          className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                          onChange={onChangeText}
                        />
                      </div>
                    </div>
                    <div className="flex pb-3 items-center">
                      <Select
                        showSearch
                        placeholder="Select item"
                        className="mt-2 ml-3 h-8 p-1 w-36"
                        optionFilterProp="children"
                        value={state.itemCode || "Item"}
                        onChange={(e) => {
                          const { itemName: productName } = state.items.find(
                            (el) => el.itemCode === e
                          );
                          setState({
                            ...state,
                            itemCode: e,
                            itemName: productName,
                          });
                        }}
                      >
                        {state.items.map((el) => (
                          <Option value={el.itemCode}>{el.itemCode}</Option>
                        ))}
                      </Select>
                      <Select
                        showSearch
                        placeholder="Select Product Name"
                        optionFilterProp="children"
                        className="mt-2 ml-3 h-8 p-1 w-60"
                        value={state.itemName || "Prodct Name"}
                        onChange={(e) => {
                          const { itemName: productName } = state.items.find(
                            (el) => el.itemCode === e
                          );
                          setState({
                            ...state,
                            itemCode: e,
                            itemName: productName,
                          });
                        }}
                      >
                        {state.items.map((el) => (
                          <Option
                            value={el.itemCode}
                          >{`${el.itemCode} - ${el.itemName}`}</Option>
                        ))}
                      </Select>
                       <button
                    className={`bg-blue-500 text-white mt-2 ml-3 py-1 px-4 rounded ${
                      loading
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:bg-blue-700"
                    }`}
                    onClick={editHandler}
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "View"}
                  </button>
                      <button
                        onClick={clearFields}
                        className="bg-blue-500 hover:bg-blue-700 text-white mt-2 ml-3 py-1 px-4 rounded"
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
     
  );
};

export default RateGainReport;
